// Shared carousel configurations
import StoryTelling from '../plugins/carousel-storytelling'
function isInSmallColumn(element) {
  const container = $(element).closest('[class*="col-md-"]')
  if (!container.length) return false
  const classes = container.attr('class').split(/\s+/)
  for (let i = 0; i < classes.length; i++) {
    const match = classes[i].match(/^col-md-(\d+)$/)
    if (match && parseInt(match[1], 10) <= 6) return true
  }
  return false
}

export const carouselConfigs = [
  {
    classSelector: 'carousel--style--default',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--infinite',
    swiperOptions: {
      ...window.Carousel_SideArrows(),
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 20,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--storytelling',
    swiperOptions: StoryTelling,
  },
  {
    classSelector: 'carousel--style--testimonials',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--home-slider',
    swiperOptions: {
      navigation: {
        nextEl: '.carousel__next',
        prevEl: '.carousel__prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--gallery',
    swiperOptions: {
      ...window.Carousel_Gallery(),
    },
  },
  {
    classSelector: 'carousel--style--rating',
    carouselOptions: {
      onBeforeInit: function(carousel) {
        if (isInSmallColumn(carousel)) {
          carousel.swiper_options.breakpoints = {
            0: {
              slidesPerView: 1,
              spaceBetween: carousel.swiper_options.breakpoints[0].spaceBetween || 0,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: carousel.swiper_options.breakpoints[768].spaceBetween || 20,
            },
          }
        }
      },
    },
  },
]
